const stringHelpers = require('../components/stringhelpers');

module.exports = function () {
    return stringHelpers.hyphenate;
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/filters/wow-hyphenate-name.js
 **/